import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Text from "../components/text";
import { Helmet } from "react-helmet-async";
function About() {
  const { About: aboutText } = Text;
  const { WhatsNew: text } = Text;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Icon SVGs for features (color comes from text.js IconColor)
  const featureIcons = {
    blue: (
      <svg
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
    ),
    green: (
      <svg
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg>
    ),
    purple: (
      <svg
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        />
      </svg>
    ),
    yellow: (
      <svg
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
        />
      </svg>
    ),
  };

  // Icon SVGs for WhyChoose div
  const whyChooseIcons = {
    personalized: (
      <svg
        className="w-8 h-8 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
        />
      </svg>
    ),
    time: (
      <svg
        className="w-8 h-8 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 10V3L4 14h7v7l9-11h-7z"
        />
      </svg>
    ),
    data: (
      <svg
        className="w-8 h-8 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        />
      </svg>
    ),
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero div */}
      <Helmet>
        <title>{Text.About.Hero.Title} | College Rank</title>
        <meta name="description" content={Text.About.Hero.Description} />
      </Helmet>
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-16 px-4">
        <div className="container mx-auto text-center max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {aboutText.Hero.Title}
          </h1>
          <p className="text-xl text-blue-100 mb-8">
            {aboutText.Hero.Description}
          </p>
          <Link
            to="/"
            className="inline-block bg-white text-blue-700 hover:bg-blue-50 font-medium px-6 py-3 rounded-lg shadow-md transition-colors"
          >
            {aboutText.Hero.ButtonText}
          </Link>
          <Link
            to="/whatsnew"
            className="mx-3 inline-block bg-blue-700 border-2 border-solid border-white text-white hover:bg-blue-200 hover:text-blue-800 font-medium px-6 py-3 rounded-lg shadow-md transition-colors"
          >
            What's New
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <div className="mb-6">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            {aboutText.AboutPlatform.Title}
          </h2>
          <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-200">
            <p className="text-gray-700 leading-relaxed mb-4">
              {aboutText.AboutPlatform.Description1}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {aboutText.AboutPlatform.Description2}
            </p>
          </div>
        </div>

        {/* Key Features div */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            {aboutText.KeyFeatures.Title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {aboutText.KeyFeatures.Features.map((feature) => (
              <div
                key={feature.Title}
                className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200"
              >
                <div className="p-6">
                  <div
                    className={`bg-${feature.IconColor}-100 text-${feature.IconColor}-600 w-12 h-12 rounded-full flex items-center justify-center mb-4`}
                  >
                    {featureIcons[feature.IconColor]}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {feature.Title}
                  </h3>
                  <p className="text-gray-600">{feature.Description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* How It Works div */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            {aboutText.HowItWorks.Title}
          </h2>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
            <div className="p-8">
              <ol className="space-y-8">
                {aboutText.HowItWorks.Steps.map((step) => (
                  <li className="flex" key={step.Number}>
                    <div className="flex-shrink-0">
                      <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold">
                        {step.Number}
                      </div>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-xl font-semibold text-gray-800 mb-1">
                        {step.Title}
                      </h3>
                      <p className="text-gray-600">{step.Description}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>

        {/* Why Choose Us div */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            {aboutText.WhyChoose.Title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {aboutText.WhyChoose.Reasons.map((reason) => (
              <div
                key={reason.Title}
                className="bg-white rounded-xl shadow-sm p-6 border border-gray-200 flex flex-col items-center text-center"
              >
                <div className="bg-blue-100 p-3 rounded-full mb-4">
                  {whyChooseIcons[reason.Icon]}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {reason.Title}
                </h3>
                <p className="text-gray-600">{reason.Description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA div */}
        <div>
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl shadow-lg overflow-hidden">
            <div className="px-6 py-12 md:px-12 text-center">
              <h2 className="text-3xl font-bold text-white mb-4">
                {aboutText.CTA.Title}
              </h2>
              <p className="text-blue-100 mb-8 max-w-2xl mx-auto">
                {aboutText.CTA.Description}
              </p>
              <Link
                to="/"
                className="inline-block bg-white text-blue-700 hover:bg-blue-50 font-medium px-6 py-3 rounded-lg shadow-md transition-colors"
              >
                {aboutText.CTA.ButtonText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
